import { BaseWorkspaceRole, MemberWorkspaceRole } from 'callabo-api/src';
import { LoadingState } from 'libs/callabo-state/types/LoadingState';
import { create } from 'zustand';

export type MemberModel = {
  id: number;
  userId: number;
  email: string;
  name: string;
  workspaceRoles: Array<MemberWorkspaceRole>;
  baseRole: BaseWorkspaceRole;
  teams: Array<{
    id: number;
    name: string;
    email?: string;
  }>;
};

type Store = {
  memberState: LoadingState<MemberModel[]>;
  refetch: () => Promise<void>;
};

export const useMemberStore = create<Store>(() => ({
  me: { type: 'unloaded' },
  memberState: { type: 'unloaded' },
  refetch: async () => undefined,
}));
export const getMemberState = (): LoadingState<MemberModel[]> => {
  return useMemberStore.getState().memberState;
};
export const useMemberState = (): LoadingState<MemberModel[]> => {
  return useMemberStore((state) => state.memberState);
};
export const setMemberState = async (memberState: LoadingState<MemberModel[]>): Promise<void> => {
  useMemberStore.setState({ memberState });
};
